import React from 'react'
import styles from './NotFound.module.css'
import Header from '../../components/Header/Header'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className={styles.page}>
      <Header isAnswersResponse={false} />

      <div className={styles.bloc}>
        <div className={styles.text_bloc}>
          <div className={styles.headline}>
            Whoops, cette page n'est pas disponible.
          </div>
          <div className={styles.headline_subtitle}>
            La page que vous recherchez a mystérieusement disparu. Plusieurs
            raisons pourraient expliquer cette absence : elle n'existe peut-être
            pas, vos autorisations pour y accéder sont insuffisantes, ou son
            délai d'affichage a expiré.
          </div>
          <div className={styles.headline}>
            <Link to={'/workspaces'}>
              <button className={styles.createButton}>
                Retour à l'accueil
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound
